import React, { useState, useEffect } from "react";
import "./ThemeToggle.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";

const ThemeToggle = () => {
  const [darkMode, setDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      return savedTheme === "dark";
    }
    return document.body.classList.contains("dark");
  });

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  return (
    <div className="toggle-container" onClick={toggleTheme}>
      <div className="icon-container sun">
        <FontAwesomeIcon icon={faSun} />
      </div>

      <div className="icon-container moon">
        <FontAwesomeIcon icon={faMoon} />
      </div>

      <div className="toggle-circle"></div>
    </div>
  );
};

export default ThemeToggle;
